import React from 'react';
import '../../style/solicitorGroup.css'
import '../../style/dots.css';
import FormResponseMessage from "../formResponseMessage";
import '../../style/formResponseMessage.css'
import Button from "../button";
import {Link} from "react-router-dom";
import _ from 'lodash';
import TobaAllocation from "../SolicitorGroups/tobaAllocation";
import CustomModal from "../General/customModal";
import TobaFormHOC from '../../containers/Tobas/tobaFormHOC';
import AdvancedDisbursements from "../SolicitorGroups/advancedDisbursements";
import SolicitorGroupGeneralTab from "./solicitorGroupGeneralTab";
import { LEGAL_ADVICE_TEXT, TOBA_SHORT_TEXT } from '../../helpers/variables';
import { FormInline, Heading, Loader } from 'arag-ui-lib';
import { FORM_GROUP_VARIANTS } from '../../helpers/formGroupVariants';
import CONTENT_STRINGS from '../../helpers/contentStrings';
import { DOTS, HEADING_2, MEDIUM } from '../../helpers/constants';

const SolicitorGroup = (props) => {

    if(props.SolicitorGroup.failedToFetchMessage) {
        return (
            <div className={'row'}>
                <FormResponseMessage
                    CenterWrapper="col-sm-12 mb-15"
                    MessageStyle="formResponseMessage-reject"
                    Message={props.SolicitorGroup.failedToFetchMessage}
                />
            </div>
        )
    }
    let route = props.router.location.pathname;
    let splitedRoute = _.split(route, '/', 5);
    // See the comment above the FormInline below for what each side of this covers.
    const displayedAragProvider = route.includes('/solicitors/solicitor-groups/edit-solicitor-group')
        ? props.SolicitorGroup.aragProvider
        : props.createModeAragProviderPreview;
    let displayedTab = '';
    const solicitorGroupTitle = route.includes('/solicitors/solicitor-groups/edit-solicitor-group') ?
        `${CONTENT_STRINGS.EDIT} ${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.GROUP}` :
        `${CONTENT_STRINGS.CREATE} ${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.GROUP}`;
    if(props.SolicitorGroup.activePanel === 'general') {
        displayedTab = <SolicitorGroupGeneralTab {...props}/>
    }
    else if(props.SolicitorGroup.activePanel === 'advancedDisbursements') {
        displayedTab = (
            <AdvancedDisbursements
                _handleAmountChange={props._handleAmountChange}
                _handleAdCheckedSubCaseTypes={props._handleAdCheckedSubCaseTypes}
                _handleAdSelectedSubCaseTypes={props._handleAdSelectedSubCaseTypes}
                _handleAdvancedDisbursementsNumberOfWeeksCheckBoxes={props._handleAdvancedDisbursementsNumberOfWeeksCheckBoxes}
                _handleAdNumberOfWeeksChange={props._handleAdNumberOfWeeksChange}
                _handleNumberOfWeeksCheckBox={props._handleAdvancedDisbursementsNumberOfWeeksCheckBox}
                _handleMultipleExpenseTypes={props._handleAdvancedDisbursementsMultipleExpenseTypes }
                _handleCheckedExpenseTypes={props._handleAdvancedDisbursementsCheckedExpenseTypes }
                _handleCheckedCaseTypes={props._handleAdvancedDisbursementsCheckedCaseTypes}
                _handleMultipleCaseTypes={props._handleAdvancedDisbursementsMultipleCaseTypes}
                caseTypes={props.caseTypes}
                subCaseTypes={props._getSubCasesBasedOnSelectedCasesAd()}
                expenseTypes={props.expenseTypes}
                formData={props.SolicitorGroup.advancedDisbursementsFormData}
                _onChange={props._handleAdvancedDisbursementsCheckBoxes}
            />
        )
    }
    else if (props.SolicitorGroup.activePanel === 'tobaAllocation') {
        displayedTab = <div>
            <div className="row mb-15">
                <div className="col-sm-12">
                    <Button clickHandler={() => props.HandleInputChange('tobaFormModalOpen', true)} wrapper="btn-wrapper"
                            btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'}
                            label={`Create new ${TOBA_SHORT_TEXT}`}/>
                </div>
            </div>
            <div className="hr--dotted"/>
            <TobaAllocation
                fetchingTobas={props.fetchingTobas}
                _changeSelectedToba={props._changeSelectedToba}
                selectedToba={props.SolicitorGroup.selectedToba}
                tobaSelectOptions={props.tobaSelectOptions}
            />
        </div>
    }

    return (
        <div className="col-sm-12">
            <CustomModal
                contentClassname='tobas__toba-modal'
                isOpen={props.SolicitorGroup.tobaFormModalOpen}
                content={<TobaFormHOC displayInModal={true} handleCancel={() => props.HandleInputChange('tobaFormModalOpen', false)}/>}
                handleClose={() => props.HandleInputChange('tobaFormModalOpen', false)}
            />
            {
                props.SolicitorGroup.deleteModal?
                    <div className="solicitorGroupList-modal">
                        <div className="solicitorGroup-deleteModal-content">
                            <div className="appFormRefSettings-close-button" onClick={() => props.HandleInputChange('deleteModal', false)}/>
                            <div className="col-xs-12">
                                Are you sure you want to delete the selected {LEGAL_ADVICE_TEXT} group?
                            </div>
                            <div className="col-xs-12">
                                <Button clickHandler={() => props.requestDeleteSolicitorGroup(splitedRoute[4])} wrapper="btn-wrapper-forForms"  btnType="button"  btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                        label="Yes" />
                                <Button clickHandler={() => props.HandleInputChange('deleteModal', false)} wrapper="btn-wrapper-forForms"  btnType="button"  btnStyle={'btn btn-primary btn-xs sharp white'}
                                        label="No" />
                            </div>
                            {
                                props.solicitorGroupsList.deleting && (
                                    <Loader variant={DOTS} dotSize={MEDIUM} />
                                )
                            }
                            {
                                props.SolicitorGroup.deleteSolicitorGroupFailMessage && (
                                    <FormResponseMessage
                                        CenterWrapper="col-xs-12" MessageStyle="formResponseMessage-reject"
                                        Message={props.SolicitorGroup.deleteSolicitorGroupFailMessage}
                                    />
                                )
                            }
                        </div>
                    </div>
                    :
                    null
            }
            {
                (
                    (
                        props.caseTypesFetchingIndicator
                        && props.caseTypes.length === 0
                    )
                    || (
                        props.SolicitorGroup.fetchingWorkSources
                        && (props.SolicitorGroup.workSources.length === 0)
                    )
                    || (
                        props.SolicitorGroup.fetchingUnderwriters
                        && (props.SolicitorGroup.underwriters.length === 0)
                    )
                    || (props.SolicitorGroup.fetchingSolicitorGroupById)
                ) ?
                    <div>
                        <div className="col-sm-5"/>
                        <Loader variant={DOTS} dotSize={MEDIUM} />
                    </div>
                    :
                    <div>
                        <Heading variant={HEADING_2} title={solicitorGroupTitle} />
                        {
                            // (edit): the backend-resolved provider, once the group has one.
                            // (create): no group exists yet to have one, so createModeAragProviderPreview
                            // (solicitorGroupHOC._getCreateModeAragProviderPreview) previews whichever
                            // provider the firms picked so far already agree on. Neither exists for a
                            // brand new form or a legacy group predating provider ownership - the doc
                            // comment on reducers/solicitorGroup.js's aragProvider field is explicit that
                            // case renders no marker rather than an empty one, so the row is skipped
                            // entirely instead of showing a blank label with no colour.
                            displayedAragProvider 
                            ?
                                <FormInline
                                    variant={FORM_GROUP_VARIANTS.PLAIN}
                                    label={`${CONTENT_STRINGS.ARAG_PROVIDER}: `}
                                    inputProps={{
                                        id: 'arag_provider',
                                        label: displayedAragProvider.providerCode,
                                        valueStyle: {backgroundColor: displayedAragProvider.providerColour},
                                    }}
                                />
                            :
                                null
                        }
                        <div className="row solicitorGroup__panel__wrapper">
                            <div className="col-sm-12">
                                <ul className='solicitorGroup__panel text-center'>
                                    <li
                                        onClick={() => props._changePanel('general')}
                                        className={props.SolicitorGroup.activePanel === 'general'?"solicitorGroup__panel__item--active":"solicitorGroup__panel__item"}
                                    >General</li>
                                    <li
                                        onClick={() =>  props._changePanel('tobaAllocation')}
                                        className={props.SolicitorGroup.activePanel === 'tobaAllocation'?"solicitorGroup__panel__item--active":"solicitorGroup__panel__item"}
                                    >TOBA Allocation</li>
                                    <li
                                        onClick={() =>  props._changePanel('advancedDisbursements')}
                                        className={props.SolicitorGroup.activePanel === 'advancedDisbursements'?"solicitorGroup__panel__item--active":"solicitorGroup__panel__item"}
                                    >Advance Disbursements</li>
                                </ul>
                            </div>
                        </div>
                        <form className="form-horizontal col-sm-9 solicitorGroup-form" onSubmit={props.HandleSubmit}>
                            {displayedTab}
                            {
                                (props.SolicitorGroup.badResponseMessage !== '') ?
                                    <FormResponseMessage
                                        LeftWrapper="col-sm-3"
                                        CenterWrapper="col-sm-9 formResponseMessage-success-solicitor-group-wrapper"
                                        MessageStyle="formResponseMessage-reject"
                                        Message={props.SolicitorGroup.badResponseMessage}
                                    />
                                    :
                                    null
                            }

                                {(props.SolicitorGroup.badResponse.length > 0) && Array.isArray(props.SolicitorGroup.badResponse) ?
                                    <div>
                                        <FormResponseMessage
                                            LeftWrapper="col-sm-3"
                                            CenterWrapper="col-sm-9 formResponseMessage-success-solicitor-group-wrapper"
                                            MessageStyle="formResponseMessage-reject"
                                            Message={
                                                <div className="">
                                                    {LEGAL_ADVICE_TEXT}(s)
                                                    <ul>{props.SolicitorGroup.badResponse.map(value => {
                                                        return (<li key={value.LawsysFirmId}>{value.LawsysFirm} - {' '}
                                                            <Link
                                                                onClick={() => props.HandleInputChange('badResponse', [])}
                                                                target="_blank"
                                                                to={'/solicitors/solicitor-groups/edit-solicitor-group/' + value.SolicitorGroupId }>(Group: {value.SolicitorGroupName}) </Link>
                                                        </li>)
                                                    })}{'already belong(s) to another group.'}</ul>
                                                    <span>Are you sure you want to make the selected changes?</span>
                                                </div>
                                            }
                                            />
                                            <div className="form-group">
                                            <div className="col-sm-3">
                                            </div>
                                            <div className="col-sm-6">
                                                <Button wrapper="btn-wrapper-forForms" btnType="submit"
                                                        btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                                        label="Yes"/>
                                                <Button clickHandler={() => props.HandleInputChange('badResponse', [])}
                                                        wrapper="btn-wrapper-forForms" btnType="button"
                                                        btnStyle={'btn btn-primary btn-xs sharp white'}
                                                        label="No"/>
                                            </div>
                                            <div className="col-sm-3"></div>
                                         </div>
                                    </div>
                                    :
                                    <div className="form-group">
                                        {(props.SolicitorGroup.badResponse.length > 0) && !Array.isArray(props.SolicitorGroup.badResponse) ?

                                        <FormResponseMessage
                                        LeftWrapper="col-sm-3"
                                        CenterWrapper="col-sm-9 formResponseMessage-success-solicitor-group-wrapper"
                                        MessageStyle="formResponseMessage-reject"
                                        Message={props.SolicitorGroup.badResponse}
                                        />
                                        :null}
                                        {props.SolicitorGroup.advancedDisbursementsFormData.adWarningMessage && Array.isArray(props.SolicitorGroup.badResponse)?
                                                null
                                                :
                                                <div>
                                                    <div className="col-sm-3">
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <Button wrapper="btn-wrapper-forForms" btnType="submit"
                                                                btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                                                label={route.includes('/solicitors/solicitor-groups/edit-solicitor-group') ?
                                                                    'Save changes' : `Save ${LEGAL_ADVICE_TEXT} Group`
                                                                }/>
                                                        <Button wrapper="btn-wrapper" btnType="button"
                                                                btnStyle={'btn btn-primary btn-xs sharp white'}
                                                                clickHandler={
                                                                    () => {
                                                                        if (route.includes('/solicitors/solicitor-groups/edit-solicitor-group')) {
                                                                            props.goBack();
                                                                        }
                                                                        else props.ChangeField('openModal', false)
                                                                    }
                                                                }
                                                                label={route.includes('/solicitors/solicitor-groups/edit-solicitor-group') ?
                                                                    'Go back' : 'Cancel'
                                                                }/>
                                                    </div>
                                                    <div className="col-sm-3"></div>
                                                </div>
                                        }
                                    </div>
                            }
                            {
                                _.size(props.SolicitorGroup.warnings) > 0?
                                    <div className="form-group">
                                        <div className="col-sm-3"></div>
                                        <div className="col-sm-8">
                                             <span><b>{'You have:'}
                                             </b>{
                                            _.map(props.SolicitorGroup.warnings, (item, index) => {return <p key={index}>{item + ','}</p>})}<b>{'Do you want to continue?'}</b>
                                             </span>
                                            <br/>
                                            <Button wrapper="btn-wrapper-forForms" btnType="submit"
                                                    btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                                    label={'Yes'}/>
                                            <Button wrapper="btn-wrapper-forForms" btnType="button"
                                                    clickHandler={
                                                        () => props.HandleInputChange('warnings', {})
                                                    }
                                                    btnStyle={'btn btn-primary btn-xs sharp white'}
                                                    label={'No'}/>
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                            {
                                (props.SolicitorGroup.failedMsg !== '') ?
                                    <FormResponseMessage
                                        LeftWrapper="col-sm-3"
                                        CenterWrapper="col-sm-9 formResponseMessage-success-solicitor-group-wrapper"
                                        MessageStyle="formResponseMessage-reject"
                                        Message={props.SolicitorGroup.failedMsg}/>
                                    :
                                    null
                            }
                            {
                                (props.SolicitorGroup.successMsg !== '') ?
                                    <FormResponseMessage
                                        LeftWrapper="col-sm-3"
                                        CenterWrapper="col-sm-9 formResponseMessage-success-solicitor-group-wrapper"
                                        MessageStyle="formResponseMessage-success"
                                        Message={props.SolicitorGroup.successMsg}/>
                                    :
                                    null
                            }
                            {
                                props.SolicitorGroup.postingGroup ?
                                    <div className="form-group">
                                        <div className="col-sm-3">
                                        </div>
                                        <div className="col-sm-9">
                                            <div className="col-sm-5"></div>
                                            <Loader variant={DOTS} dotSize={MEDIUM} />
                                        </div>
                                    </div>
                                    :
                                    null

                            }
                            {
                                route.includes('/solicitors/solicitor-groups/edit-solicitor-group') &&
                                props.SolicitorGroup.activePanel === 'general'?
                                    <div className="form-group">
                                        <div className="col-sm-3">
                                        </div>
                                        <div className="col-sm-8 ">
                                            <Button
                                                clickHandler={() => props.HandleInputChange('deleteModal', true)}
                                                wrapper="btn-wrapper" btnType="button"
                                                btnStyle={'btn btn-primary btn-xs sharp white'}
                                                label="Delete"/>
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                        </form>
                        <Button
                          clickHandler={() => props.push('/solicitors/solicitor-groups/edit-solicitor-group/' + props.SolicitorGroup.receivedGroupId + '/spec')}
                          wrapper="btn-wrapper" btnType="button"
                          btnStyle={'btn btn-primary btn-xs sharp white'}
                          label="Generate spec "/>
                    </div>
            }
        </div>
    )
};

export default SolicitorGroup;
